import Step from './step';
import {createElement} from 'methods/utils';

function PhoneAuthCodeStep(modal, options = {}) {
    const className = `PhoneAuthCodeStep`;
    const $element = createElement(
        `<div class="${className}"></div>`
    );

    Step.call(this, modal, $element, options);

    $element.insertAdjacentHTML('afterbegin',
        `<div class="${className}__wrapper">
            <form action="/lk/ajax_login/" method="POST">
                <input type="hidden" name="phone" value="${this.options.phone}">
                <input type="hidden" name="code" value="${this.options.code}">
                <div class="${className}__subtitle">
                    Мы отправили СМС на номер <div class="js-phone">${this.options.phone}</div>
                </div>
                <div class="${className}__code">
                    <div class="${className}__code-title">Введите код из СМС</div>
                    <div class="${className}__code-digits">
                        ${[...new Array(this.options.length)].map((v, i) => (
                            `<div class="${className}__code-digit">
                                <input class="js-digit-input" type="tel" maxlength="1" autocomplete="off">
                            </div>`
                        )).join('')}
                    </div>
                    <div class="${className}__code-info">
                        <div class="${className}__code-error js-error"></div>
                        <div class="${className}__code-timeout js-timeout"></div>
                        <div class="${className}__code-retry js-retry">Отправить повторно</div>
                    </div>
                </div>
                <button class="${className}__submit js-submit">Подтвердить код</button>
                <div class="${className}__do-not-contact-us">Возникли проблемы? Напишите в <a href="/faq/">службу поддержки</a></div>
            </form>
        </div>`
    );

    this.autoSubmit = !!this.options.autoSubmit;

    this.$form = this.$element.querySelector('form');
    this.$phone = this.$element.querySelector('.js-phone');
    this.$error = this.$element.querySelector('.js-error');
    this.$timeout = this.$element.querySelector('.js-timeout');
    this.$submit = this.$element.querySelector('.js-submit');

    this.$retry = this.$element.querySelector('.js-retry');
    this.$retry.addEventListener('click', () => {
        this.modal.prevStep();
    });

    this.$form.addEventListener('submit', e => {
        e.preventDefault();
        this.submit();
    });

    this.inputMaskMap = new WeakMap();

    this.getInputs().forEach(($input, index, $inputs) => {
        const $nextInput = $inputs[index + 1];
        const $prevInput = $inputs[index - 1];

        const mask = IMask($input, {
            mask: '0',
        });

        this.inputMaskMap.set($input, mask);

        $input.addEventListener('keydown', this.onKeyDown.bind(this, $input, $nextInput, $prevInput));
        $input.addEventListener('input', this.onInput.bind(this, $input, $nextInput, $prevInput));
        $input.addEventListener('focus', this.onFocus.bind(this, $input));
        $input.addEventListener('paste', this.onPaste.bind(this, $input));
    });
}

PhoneAuthCodeStep.prototype = Object.create(Step.prototype);
Object.defineProperty(PhoneAuthCodeStep.prototype, 'constructor', {
    value: PhoneAuthCodeStep,
    enumerable: false,
    writable: true,
});

PhoneAuthCodeStep.prototype.auth = function() {
    return new Promise((resolve, reject) => {
        this._authPromiseResolve = resolve;
        this._authPromiseReject  = reject;
    });
}

PhoneAuthCodeStep.prototype.setOptions = function(options) {
    Step.prototype.setOptions.call(this, Object.assign({
        phone: '',
        code: '',
        length: 4,
        autoSubmit: true,
    }, options));
}

PhoneAuthCodeStep.prototype.showError = function(text) {
    this.$error.textContent = text;
    this.$error.classList.add('is-active');
    const animation = this.$error.animate([
        {opacity: 0},
        {opacity: 1},
    ], 100);
}

PhoneAuthCodeStep.prototype.hideError = function() {
    const animation = this.$error.animate([
        {opacity: 0},
    ], 100);

    animation.finished.then(() => {
        this.$error.classList.remove('is-active');
    });
}

PhoneAuthCodeStep.prototype.getInputs = function() {
    return [...this.$element.querySelectorAll('.js-digit-input')];
}

PhoneAuthCodeStep.prototype.onKeyDown = function($input, $nextInput, $prevInput, e) {
    if (e.key == 'Backspace' && !$input.value.length && $prevInput) {
        this.focusInput($prevInput);
    }

    if (e.key == 'Delete') {
        e.preventDefault();
        this.inputMaskMap.get($input).value = '';
    }

    if (e.key == 'ArrowLeft' && $prevInput) {
        e.preventDefault();
        this.focusInput($prevInput);
    }

    if (e.key == 'ArrowRight' && $nextInput) {
        e.preventDefault();
        this.focusInput($nextInput);
    }

    this.updateCodeInputValue();
}

PhoneAuthCodeStep.prototype.onInput = function($input, $nextInput, $prevInput, e) {
    const isComplete = this.inputMaskMap.get($input).masked.isComplete;

    if (isComplete && $nextInput) {
        this.focusInput($nextInput);
    }

    this.updateCodeInputValue();
}

/**
 * Фокус в поле, требующее ввода
 * @return {HTMLElement} Элемент в фокусе
 */
PhoneAuthCodeStep.prototype.focus = function() {
    return this.getInputs().find(($input, index, arr) => {
        this.focusInput($input);
        return !$input.value.length || index == arr.length - 1;
    });
}

PhoneAuthCodeStep.prototype.focusInput = function($input) {
    $input.focus();
    // $input.select();
}

PhoneAuthCodeStep.prototype.onFocus = function($input) {
    this.focusInput($input);
}

PhoneAuthCodeStep.prototype.onPaste = function($input, e) {
    e.preventDefault();
    const value = (e.clipboardData || window.clipboardData).getData('text');
    this.setCode(value);
}

PhoneAuthCodeStep.prototype.getCode = function() {
    return this.getInputs().map($input => $input.value).join('');
}

PhoneAuthCodeStep.prototype.setCode = function(value) {
    const parts = (value || '').toString().split('').slice(0, this.options.length);

    this.getInputs().forEach(($input, index) => {
        const mask = this.inputMaskMap.get($input);
        mask.value = parts[index] || '';
    });

    // после вставки кода из буфера лучше смотрится когда последний элемент не выделен
    const $focusInput = this.focus();
    $focusInput.selectionStart = $focusInput.selectionEnd;

    this.updateCodeInputValue();
}

PhoneAuthCodeStep.prototype.validate = function() {
    return this.getCode().length == this.options.length;
}

PhoneAuthCodeStep.prototype.updateCodeInputValue = function() {
    this.$form.elements.code.value = this.getCode();

    if (this.autoSubmit && this.validate()) {
        this.submit();
        this.autoSubmit = false;
    }
}

PhoneAuthCodeStep.prototype.setPhone = function(phone) {
    this.$form.elements.phone.value = phone;
    this.$phone.textContent         = phone;
}

PhoneAuthCodeStep.prototype.show = function() {
    this.modal.setTitle('Вход в личный кабинет');
    this.modal.setCanPrevStep(true);
    this.hideError();
    this.setCode('');
    this.focus();
}

PhoneAuthCodeStep.prototype.hide = function() {
    this.hideError();
}

PhoneAuthCodeStep.prototype.submit = function() {
    const formData = new FormData(this.$form);

    this.$submit.classList.add('is-loading');

    return fetch(this.$form.action, {
        method: this.$form.method,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            this.showError(r.message);
            return;
        }

        (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(() => {
            try {
                rrApi.setCustomer({
                    customerId: `lk-user${r.data.id}`,
                    name: r.data.name,
                    phone: r.data.phone,
                    email: r.data.email,
                });
            } catch(e) {
                error(e);
            }
        });

        this._authPromiseResolve(r.data);
    }).finally(() => {
        this.$submit.classList.remove('is-loading');
    });
}

PhoneAuthCodeStep.prototype.startTimeout = function(seconds) {
    this.stopTimeout();

    this.$retry.classList.remove('is-active');

    const targetDate = new Date();
    targetDate.setSeconds(targetDate.getSeconds() + seconds);

    this.timeoutInterval = setInterval(() => {
        const now = new Date();
        const remaining = Math.max(0, Math.ceil((targetDate.getTime() - now.getTime()) / 1000));

        if (!remaining) {
            this.showError('Время ввода кода истекло');
            this.$retry.classList.add('is-active');
            this.$retry.animate({
                opacity: [0, 1],
            }, 100);
            this.stopTimeout();
            return;
        }

        this.$timeout.textContent = `Повторно отправить код можно через ${remaining} сек`;
    }, 100);
}

PhoneAuthCodeStep.prototype.stopTimeout = function() {
    clearInterval(this.timeoutInterval);
    delete this.timeoutInterval;
    this.$timeout.textContent = '';
}

PhoneAuthCodeStep.prototype.isTimeout = function() {
    return typeof this.timeoutInterval != 'undefined';
}

export default PhoneAuthCodeStep;
